module.exports = __webpack_public_path__ + "img/logo2.5fe2d003.png";